import { forwardRef, createElement } from 'react';

function IconListSearch(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M17.5 11a4.5 4.5 0 013.632 7.158l.036-.05 1.862 1.862a.75.75 0 01-.976 1.133l-.084-.073-1.863-1.862-.112.077A4.5 4.5 0 1117.5 11zm-6.25 7.5a.75.75 0 110 1.5h-8.5a.75.75 0 110-1.5h8.5zm6.25-6a3 3 0 100 6 3 3 0 000-6zm-7.25 1.167a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5zm3-4.834a.75.75 0 110 1.5H2.75a.75.75 0 110-1.5h10.5zm8-4.833a.75.75 0 110 1.5H2.75a.75.75 0 010-1.5h18.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ListSearch = /*#__PURE__*/forwardRef(IconListSearch);

export default ListSearch;
//# sourceMappingURL=ListSearch.js.map
